var _circle, _mask, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisualizeAccounts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#323232"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_187_407",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.7734,
    y: 15.5889,
    width: 25.9685,
    height: 32.4606,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.7734,
    y: 15.5889,
    width: 25.9685,
    height: 32.4606,
    rx: 2,
    stroke: "white",
    strokeWidth: 5,
    mask: "url(#path-2-inside-1_187_407)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0859 25.327V15.5889L44.7421 25.327H36.0859Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.906 14.507V28.5732L35.0038 14.507H46.906Z",
    fill: "#323232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5657 44.6404C31.6191 44.6404 30.7524 44.4671 29.9657 44.1204C29.1791 43.7604 28.5124 43.2737 27.9657 42.6604C27.4191 42.0471 27.0257 41.3604 26.7857 40.6004L28.4857 39.9004C28.8457 40.8604 29.3791 41.6004 30.0857 42.1204C30.8057 42.6271 31.6457 42.8804 32.6057 42.8804C33.1924 42.8804 33.7057 42.7871 34.1457 42.6004C34.5857 42.4137 34.9257 42.1537 35.1657 41.8204C35.4191 41.4737 35.5457 41.0737 35.5457 40.6204C35.5457 39.9937 35.3657 39.5004 35.0057 39.1404C34.6591 38.7671 34.1457 38.4871 33.4657 38.3004L30.7257 37.4604C29.6457 37.1271 28.8191 36.6004 28.2457 35.8804C27.6724 35.1604 27.3857 34.3337 27.3857 33.4004C27.3857 32.5871 27.5791 31.8737 27.9657 31.2604C28.3657 30.6337 28.9124 30.1471 29.6057 29.8004C30.3124 29.4404 31.1124 29.2604 32.0057 29.2604C32.8991 29.2604 33.7057 29.4204 34.4257 29.7404C35.1591 30.0604 35.7791 30.4937 36.2857 31.0404C36.7924 31.5737 37.1657 32.1871 37.4057 32.8804L35.7257 33.5804C35.4057 32.7404 34.9257 32.1071 34.2857 31.6804C33.6457 31.2404 32.8924 31.0204 32.0257 31.0204C31.4924 31.0204 31.0191 31.1137 30.6057 31.3004C30.2057 31.4737 29.8924 31.7337 29.6657 32.0804C29.4524 32.4137 29.3457 32.8137 29.3457 33.2804C29.3457 33.8271 29.5191 34.3137 29.8657 34.7404C30.2124 35.1671 30.7391 35.4937 31.4457 35.7204L33.9457 36.4604C35.1191 36.8204 36.0057 37.3337 36.6057 38.0004C37.2057 38.6671 37.5057 39.4937 37.5057 40.4804C37.5057 41.2937 37.2924 42.0137 36.8657 42.6404C36.4524 43.2671 35.8724 43.7604 35.1257 44.1204C34.3924 44.4671 33.5391 44.6404 32.5657 44.6404ZM31.6657 46.4004V27.5004H33.1657V46.4004H31.6657Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1501 23.04L56.6041 26.5826L53.1501 29.948",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6045 26.4946H46.9333",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.387 40.1064L46.933 36.5639L50.387 33.1985",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9331 36.6528L56.6042 36.6528",
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizeAccounts);
export default __webpack_public_path__ + "static/media/visualize_accounts.4356409d5980887ef4b65d0cb74c62db.svg";
export { ForwardRef as ReactComponent };